import { render } from "./SearchResultItem.vue?vue&type=template&id=b6fa7804&scoped=true"
import script from "./SearchResultItem.vue?vue&type=script&lang=js"
export * from "./SearchResultItem.vue?vue&type=script&lang=js"

import "./SearchResultItem.vue?vue&type=style&index=0&id=b6fa7804&scoped=true&lang=css"

import exportComponent from "/home/www/.jenkins/workspace/131-front-vue-8081/code/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6fa7804"]])

export default __exports__